(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/carousel.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/carousel.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Children,
  isValidElement,
  useCallback,
  useEffect,
  useRef,
  useState
} = React;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  CarouselItem,
  CarouselNavigation
} = svs.components.lbUi.carousel;
const {
  useDrag
} = svs.components.carousel.hooks;
const {
  clx,
  onScrollEnd
} = svs.components.lbUtils;
const {
  usePrevious
} = svs.components.lbUtils.usePrevious;
const {
  Skeleton
} = svs.components.lbUi;
const DRAG_THRESHOLD = 50;

const Carousel = _ref => {
  var _children, _children2, _children3, _children5, _children6, _children7;
  let {
    branding,
    children,
    className,
    options
  } = _ref;
  children = Array.isArray(children) ? children : [children];
  const defaultOptions = {
    align: 'start',
    gutter: 1,
    isMobile: false,
    itemsPerPage: 4
  };
  const {
    align,
    cardSize,
    gutter,
    itemsPerPage,
    isMobile,
    selectedIndex,
    usePlaceholders,
    useSkeleton
  } = _objectSpread(_objectSpread({}, defaultOptions), options);

  const placeholders = usePlaceholders || useSkeleton ? [...Array(Math.max(0, itemsPerPage - ((_children = children) === null || _children === void 0 ? void 0 : _children.length))).keys()].map(key => React.createElement(CarouselItem, {
    key: "placeholder-".concat(key)
  }, useSkeleton ? React.createElement(Skeleton, {
    className: "carousel-skeleton"
  }) : React.createElement("div", {
    className: "carousel-placeholder-item"
  }))) : [];

  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const mobileView = isMobile || isMobileQuery;

  const [index, setIndex] = useState(() => {
    if (children.length > itemsPerPage && selectedIndex > 0) {
      return Math.floor(selectedIndex / itemsPerPage);
    }
    return 0;
  });

  const lastIndex = usePrevious(index);

  const ref = useRef(null);

  const {
    disable,
    enable,
    release,
    registerCallbacks
  } = useDrag(ref);

  const [numberOfPages, setNumberOfPages] = useState(Math.ceil(((_children2 = children) === null || _children2 === void 0 ? void 0 : _children2.length) / itemsPerPage));

  const savedState = useRef({
    numberOfPages,
    itemsPerPage,
    index,
    total: (_children3 = children) === null || _children3 === void 0 ? void 0 : _children3.length,
    isScrolling: false,
    mobileIndex: null
  });

  const transformCards = el => {
    if (el) {
      const parentBounds = el.getBoundingClientRect();
      const parentCenter = Math.round(parentBounds.left + parentBounds.width / 2);
      for (let i = 0; i < el.children.length; i++) {
        const card = el.children[i];
        const cardBounds = card.getBoundingClientRect();
        const cardCenter = Math.round(cardBounds.left + cardBounds.width / 2);
        const diff = Math.abs(cardCenter - parentCenter);
        card.firstChild.style.setProperty('--offset', Math.min(1, diff / cardBounds.width));
        if (diff < 50) {
          savedState.current.mobileIndex = i;
        }
      }
    }
  };

  const getPositionForIndex = useCallback(index => {
    var _ref$current;
    const children = [...(((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.children) || [])];
    if (!children.length) {
      return 0;
    }
    const bounds = children[0].getBoundingClientRect();
    const n = Math.min(children.length - itemsPerPage, index * itemsPerPage);
    return Math.max(0, n * bounds.width);
  }, [itemsPerPage]);

  const moveToPageIndex = useCallback(function (index) {
    let instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const x = getPositionForIndex(index);
    if (ref.current.scrollLeft !== x) {
      ref.current.scrollTo({
        left: x,
        behavior: instant ? 'instant' : 'smooth'
      });
    }
  }, [getPositionForIndex]);

  const onReleaseDrag = () => {
    savedState.current.isScrolling = false;
  };

  const onStart = () => {
    savedState.current.isScrolling = true;
  };

  const onMove = _ref2 => {
    let {
      x
    } = _ref2;
    if (!mobileView) {
      if (Math.abs(x) > DRAG_THRESHOLD) {
        const {
          numberOfPages
        } = savedState.current;
        release();
        setIndex(i => {
          const newIndex = x > 0 ? Math.max(0, i - 1) : Math.min(numberOfPages - 1, i + 1);
          savedState.current.index = newIndex;
          return newIndex;
        });
      }
    }
  };

  const onEnd = () => {
    savedState.current.isScrolling = false;
  };

  registerCallbacks({
    onStart,
    onMove,
    onEnd,
    onReleaseDrag
  });

  useEffect(() => {
    if (index >= 0) {
      moveToPageIndex(index);
    }
  }, [index, lastIndex, mobileView, moveToPageIndex]);

  useEffect(() => {
    const scrollArea = ref === null || ref === void 0 ? void 0 : ref.current;
    const handleTransforms = () => {
      transformCards(scrollArea);
      if (!savedState.current.isScrolling) {
        savedState.current.isScrolling = onScrollEnd(scrollArea, () => {
          savedState.current.isScrolling = false;
        });
      }
    };
    if (mobileView) {
      transformCards(scrollArea);
      scrollArea.addEventListener('scroll', handleTransforms);
    }
    return () => {
      scrollArea === null || scrollArea === void 0 || scrollArea.removeEventListener('scroll', handleTransforms);
    };
  }, [mobileView]);

  useEffect(() => {
    const {
      mobileIndex
    } = savedState.current;
    if (mobileIndex !== null) {
      const readIndex = Math.floor(mobileIndex / itemsPerPage);
      if (readIndex !== index) {
        setIndex(readIndex);
      }
      savedState.current.mobileIndex = null;
    }
  }, [index, itemsPerPage, setIndex]);
  if (mobileView) {
    disable();
  } else {
    enable();
  }

  useEffect(() => {
    var _children4;
    const newNumberOfPages = Math.ceil(((_children4 = children) === null || _children4 === void 0 ? void 0 : _children4.length) / itemsPerPage);
    savedState.current = _objectSpread(_objectSpread({}, savedState.current), {}, {
      numberOfPages: newNumberOfPages,
      itemsPerPage
    });
    setNumberOfPages(newNumberOfPages);
  }, [(_children5 = children) === null || _children5 === void 0 ? void 0 : _children5.length, itemsPerPage]);
  useEffect(() => {
    const scrollArea = ref.current;
    if (mobileView) {
      setTimeout(() => {
        if (scrollArea.scrollLeft === 0) {
          scrollArea.scrollTo({
            left: 20,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    if (selectedIndex) {
      moveToPageIndex(selectedIndex, true);
    }
  }, []);

  useEffect(() => {
    if (selectedIndex >= 0) {
      const maxIndex = Math.floor(children.length / itemsPerPage);
      const pageToView = Math.floor(selectedIndex / itemsPerPage);
      if (index === pageToView) {
        moveToPageIndex(pageToView, true);
      } else if (!(lastIndex === maxIndex && selectedIndex >= children.length - itemsPerPage)) {
        setIndex(pageToView);
      }
    }
  }, [selectedIndex]);
  const styles = _objectSpread({
    '--carousel-align': align,
    '--carousel-gutter': gutter,
    '--carousel-per-page': itemsPerPage
  }, cardSize ? {
    '--carousel-card-size': "".concat(cardSize, "px")
  } : {});
  return (((_children6 = children) === null || _children6 === void 0 ? void 0 : _children6.length) > 0 || useSkeleton && !((_children7 = children) !== null && _children7 !== void 0 && _children7.length)) && React.createElement("div", {
    className: clx('carousel', {
      ["carousel-".concat(branding)]: branding,
      'carousel-mobile': mobileView
    }, className),
    style: styles
  }, React.createElement("div", {
    className: "carousel-items",
    "data-testid": "carousel-items",
    ref: ref
  }, Children.map(children, (child, childIndex) => {
    if (isValidElement(child)) {
      return React.createElement(CarouselItem, {
        isSelected: childIndex === selectedIndex,
        key: child.key
      }, child);
    }
    return null;
  }), placeholders), !mobileView && React.createElement(CarouselNavigation, {
    disabled: children.length <= itemsPerPage,
    numberOfPages: numberOfPages,
    onChange: i => setIndex(i),
    selectedIndex: index
  }));
};
Carousel.defaultProps = {
  children: []
};
setGlobal('svs.components.lbUi.carousel.Carousel', Carousel);

 })(window);